/**
 * Registration request email configuration.
 * Used by Login and other components to provide a consistent registration experience.
 */

const REGISTRATION_SUBJECT = 'Registration Request';
const REGISTRATION_BODY = `Welcome to the DNAwiz crowd!

To set up your user profile 
as a responsible member 
of a human genetic community, 
please provide the following information:

Family Name: 

First Name:

Educational background:    

Academic degree:

Actual professional position/role:

Institution:                                     

Address Institution:

Contact information

Mail:                                                  

Phone:

We will get back to you shortly. 

The bio.logis team`;

const SUPPORT_EMAIL = 'dnawiz-support@biologis.eu';

export const REGISTRATION_MAILTO_HREF = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
  REGISTRATION_SUBJECT,
)}&body=${encodeURIComponent(REGISTRATION_BODY)}`;
